import DuplicateDefinition from "../../../../components/DataCollection/Unifier/UniqueDefinitions/DuplicateDefinition/DuplicateDefinition";

const DuplicateDefinitionScreen = () => {
  return (
    <>
      <DuplicateDefinition />
    </>
  );
};

export default DuplicateDefinitionScreen;
